const Background = () => {
  return (
    <section class="bsb-timeline-1 py-5 py-xl-8">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-10 col-md-8 col-xl-6">

            <ul id="timelineLine" class="timeline">
              <li class="timeline-item">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <div class="card border-0">
                      <div class="card-body p-2">
                        <h5 class="card-subtitle text-secondary m-2">2019</h5>
                        <p class="card-text mb-2">Didn't own a laptop at the time. Become interested in programming and start learning C++ on an android compiler.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="timeline-item">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <div class="card border-0">
                      <div class="card-body p-2">
                        <h5 class="card-subtitle text-secondary m-2">2020</h5>
                        <p class="card-text mb-2">Take my first C++ class as an Electrical Engineering student. Absolutely fall in love with coding and decide to switch majors!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="timeline-item">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <div class="card border-0">
                      <div class="card-body p-2">
                        <h5 class="card-subtitle text-secondary m-2">2022</h5>
                        <p class="card-text mb-2">Build my first "hangman" website. Start researching web dev and gaming frameworks to build small projects.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="timeline-item">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <div class="card border-0">
                      <div class="card-body p-2">
                        <h5 class="card-subtitle text-secondary m-2">2023</h5>
                        <p class="card-text mb-2">Get my first CS related job as a Data Structures and Algorithms tutor and become a pro at solving coding challenges.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="timeline-item">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <div class="card border-0">
                      <div class="card-body p-2">
                        <h5 class="card-subtitle text-secondary m-2">Summer 2024</h5>
                        <p class="card-text mb-2">
                          <li><p className='Main-point m-0'>Graduate as a Computer Engineer</p><li>University of Texas Rio Grande Valley</li><li>Magna Cum Laude</li><li>GPA: 3.87</li></li>
                          <br></br><li><p className='Main-point m-0'>Get my first programming job</p><li>AI Training Coder at Outlier.AI</li></li>
                          <br></br><li><p className='Main-point m-0'>Obtain Certifications</p><li>Codepath's Technical Interview Prep</li></li>
                          <br></br><li><p className='Main-point m-0'>Become a Software Engineering Fellow</p><li>Headstarter AI</li></li>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li class="timeline-item">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <div class="card border-0">
                      <div class="card-body p-2">
                        <h5 class="card-subtitle text-secondary m-2">Fall 2024 - Present</h5>
                        <p class="card-text mb-2">
                          <li><p className='Main-point m-0'>Work for a startup!</p><li>MVSSIVE</li></li>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li id="timeline" class="timeline-item">
                <div class="timeline-body">
                  <div class="timeline-content">
                    <div class="card border-0">
                      <div class="card-body p-2">
                        <h5 class="card-subtitle text-secondary m-2">2026</h5>
                        <h2 class="card-title mb-3">Next Milestone</h2>
                        <p class="card-text mb-2">Land a Software Engineering role and become a Software Engineer!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Background;
